// extracted by mini-css-extract-plugin
module.exports = {"myRecommendations":"recommendations_myRecommendations__3ik_Z"};